<template>
    <div>
        <div class="table-header row">
            <div>
                <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="selectAllChange"
                />
            </div>
            <div>
                网吧名
            </div>
            <div>
                计算机名
            </div>
            <div class="column">
                <span>服务器标签</span>
                <div
                    v-show="columnShowLabel"
                    @click.prevent="column('label', 'asc')"
                >
                    <img src=@/assets/img/icon/u231.png class="up"/>
                </div>
                <div
                    v-show="!columnShowLabel"
                    @click.prevent="column('label', 'desc')"
                >
                    <img src=@/assets/img/icon/u231.png class="down"/>
                </div>
            </div>
            <div class="column">
                <span>类型</span>
                <div
                    v-show="columnShowType"
                    @click.prevent="column('type', 'asc')"
                >
                    <img src=@/assets/img/icon/u231.png class="up" />
                </div>
                <div
                    v-show="!columnShowType"
                    @click.prevent="column('type', 'desc')"
                >
                    <img src=@/assets/img/icon/u231.png class="down"/>
                </div>
            </div>
            <div class="column">
                <span>分组名</span>
                <div
                    v-show="columnShowGroup"
                    @click.prevent="column('groupName', 'asc')"
                >
                    <img src=@/assets/img/icon/u231.png class="up" />
                </div>
                <div
                    v-show="!columnShowGroup"
                    @click.prevent="column('groupName', 'desc')"
                >
                    <img src=@/assets/img/icon/u231.png class="down"/>
                </div>
            </div>
        </div>
        <div class="table-body">
            <div
                class="row"
                v-for="(item, index) in barServerList"
                :key="index"
            >
                <!-- 选中 -->
                <div>
                    <input
                        type="checkbox"
                        v-model="item.select"
                        @change="selectChange(item.select)"
                    />
                </div>
                <!-- 网吧名 -->
                <div>
                    <span v-text="item.barName"></span>
                </div>
                <!-- 计算机名 -->
                <div>
                    <span v-text="item.computerName"></span>
                </div>
                <!-- 服务器标签 -->
                <div>
                    <span v-text="$PropFn.safeDislayValue(item.label)"></span>
                </div>
                <!-- 类型 -->
                <div>
                    <span v-if="item.type == 1">主</span>
                    <span v-if="item.type == 0">副</span>
                </div>
                <!-- 分组名 -->
                <div>
                    <span v-text="item.groupName"></span>
                </div>
            </div>
            <no-data
                style="height:auto;padding-top:20px;padding-bottom:20px;"
                v-show="tableList.length == 0 || loading"
                :nodata="tableList.length == 0 && !loading"
                :loading="loading"
            ></no-data>
        </div>
        <div class="table-pagination" v-show="tableList.length > 0">
            <div style="float:left;padding-left:10px;">
                <div
                    class="default-btn"
                    style="margin-left:10px;cursor: pointer;"
                    @click.prevent="selectPageChange"
                >
                    <span>全选本页</span>
                </div>
                <div
                    class="default-btn"
                    style="margin-left:10px;cursor: pointer;"
                    @click.prevent="chooseAllPage"
                >
                    <span>全选所有</span>
                </div>
            </div>
            <page-component
                :total="total"
                :current-page="page"
                @pagechange="pagechange"
            ></page-component>
        </div>
    </div>
</template>

<script>
// 分页功能
import PageComponent from "_c/pagination/pageComponent";
import NoData from "_c/noData/noData";

export default {
    name: "tableData",
    components: {
        PageComponent,
        NoData
    },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            }
        },
        total: {
            type: Number,
            default: 0
        },
        page: {
            type: Number,
            default: 0
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isSelectAll: false,
            barServerList: [],
            allCheck: false,
            columnShowLabel: false,
            columnShowType: false,
            columnShowGroup: false
        };
    },
    watch: {
        tableList() {
            this.isSelectAll = false;
            this.barServerList = this.tableList.map(item => {
                item.select = false;
                return item;
            });
            if (this.allCheck) {
                this.isSelectAll = true;
                this.barServerList.forEach(item => {
                    item.select = true;
                });
            } else {
                this.isSelectAll = false;
                this.barServerList.forEach(item => {
                    item.select = false;
                });
            }
        }
    },
    methods: {
        selectedBarIds() {
            let arr = [];
            this.barServerList.forEach(item => {
                if (item.select) {
                    arr.push({
                        barId: item.barId,
                        barServerFlag: item.flag,
                        computerName: item.computerName
                    });
                }
            });
            return arr;
        },
        pagechange(page) {
            this.$emit("pagechange", page, "", "");
        },
        selectAllChange() {
            if (this.isSelectAll) {
                this.barServerList.forEach(item => {
                    item.select = true;
                });
            } else {
                this.barServerList.forEach(item => {
                    item.select = false;
                });
            }
            this.allCheck = false;
        },
        selectPageChange() {
            this.isSelectAll = true;
            this.barServerList.forEach(item => {
                item.select = true;
            });
            this.allCheck = false;
        },
        selectChange(selectState) {
            if (selectState) {
                // 对单项进行选中
                // 判断是否全部选中
                let selectAllState = this.barServerList.every(item => {
                    return item.select == true;
                });
                // 若全部选中,则为全选状态
                if (selectAllState) {
                    this.isSelectAll = true;
                }
            } else {
                // 对单项进行取消
                this.isSelectAll = false;
            }
            this.allCheck = false;
        },
        chooseAllPage() {
            this.isSelectAll = true;
            this.barServerList.forEach(item => {
                item.select = true;
            });
            this.allCheck = true;
        },
        column(val, col) {
            if (val == "label" && col == "asc") {
                this.columnShowLabel = false;
            }
            if (val == "label" && col == "desc") {
                this.columnShowLabel = true;
            }
            if (val == "type" && col == "asc") {
                this.columnShowType = false;
            }
            if (val == "type" && col == "desc") {
                this.columnShowType = true;
            }
            if (val == "groupName" && col == "asc") {
                this.columnShowGroup = false;
            }
            if (val == "groupName" && col == "desc") {
                this.columnShowGroup = true;
            }
            this.$emit("labelColumn", val, col);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
    width: 100%;
    cursor: pointer;
    @include clearfix();
    &:after {
        content: "";
        top: 0;
        left: 0;
        display: block;
        font-size: 0;
        height: 0;
        width: 0;
        clear: both;
        visibility: hidden;
    }
    > div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 30px;
        span {
            @include ellipsis();
            display: inline-block;
            max-width: 100%;
        }
        p {
            @include ellipsis();
            max-width: 100%;
        }
        a {
            text-align: left;
            text-indent: 0px;
            margin-right: 8px;
            color: #0066cc;
        }
        input {
            cursor: pointer;
        }
    }

    > div:nth-child(1) {
        width: 5%;
        text-indent: 10px;
        input {
            position: relative;
            top: 2px;
        }
    }
    > div:nth-child(2) {
        width: 20%;
    }
    > div:nth-child(3) {
        width: 25%;
    }
    > div:nth-child(4) {
        width: 20%;
    }
    > div:nth-child(5) {
        width: 10%;
    }
    > div:nth-child(6) {
        width: 20%;
    }
}
.column {
    overflow: hidden;
    span,
    div {
        float: left;
    }
    div {
        display: inline-block;
        width: 10px;
        height: 100%;
        float: left;
        margin-left: 3px;
        position: relative;
        img {
            position: absolute;
            top: 12px;
        }
        .up {
            transform: rotate(180deg);
        }
    }
}
.table-header {
    border-top: none;
    > div {
        height: 30px;
        line-height: 30px;
    }
}
.table-body,
.table-pagination {
    background: #fff;
}
.table-body {
    border-left: 1px solid rgba(230, 230, 230, 1);
    border-right: 1px solid rgba(230, 230, 230, 1);
    .row {
        height: 30px;
        line-height: 30px;
    }
}
.bar-name {
    p {
        line-height: normal;
        line-height: 14px;
    }
    p:nth-child(1) {
        padding-top: 10px;
    }
}
.gray-word {
    color: $gray-word;
}
.server {
    .online {
        span {
            color: $green;
        }
    }
    .offline {
        span {
            color: $gray-word;
        }
    }
    img {
        position: relative;
        vertical-align: top;
        top: 18px;
        margin-right: 4px;
    }
}

.table-pagination {
    text-align: right;
    border: 1px solid rgba(230, 230, 230, 1);
    border-top: none;
    padding-top: 20px;
    padding-right: 5px;
    > div {
        display: inline-block;
    }
}
input[type="checkbox"] {
    cursor: pointer;
}
</style>
